import request from "@/utils/request";
import { VUE_APP_API_OUT_URL, VUE_APP_API_OUT_URL5000 } from "@/config";
const certificate_id = "TrendTrade";
import axios from "axios";

export function notes(where) {
  //查询投资笔记
  return request.post("/business/notes", where);
}

export function getNotes(where) {
  //查询投资笔记列表
  return request.get("/business/notes", where);
}

export function getNotesInfo(where) {
  //查询投资笔记详情
  return request.get("business/notes/info", where);
}

export function amendNotes(where) {
  //修改笔记
  return request.put("business/notes", where);
}

export function deleteNotes(where) {
  //删除笔记
  return request.delete("business/notes", where);
}

// 小程序二维码
export function maCode(where) {
  return request.get("/wechat/maCode", where);
}

// 获取banner图片
export function getBanner(where) {
  return request.get("/business/banner", where);
}

// 获取皂富知识
export function getKnowledge(where) {
  return request.get("/business/trend", where);
}

// 获取首页股票数据
export function getMiniStockList(where) {
  where.certificate_id = certificate_id;
  return new Promise((resolve, reject) => {
    var data = JSON.stringify(where);
    var config = {
      method: "post",
      url: VUE_APP_API_OUT_URL + "/TrendTrade/TrendHot",
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };
    axios(config)
      .then(function (response) {
        resolve(JSON.parse(JSON.stringify(response.data)));
      })
      .catch(function (error) {
        reject(error);
      });
  });
}

// 获取股票数据
export function getStockList(where) {
  where.certificate_id = certificate_id;
  return new Promise((resolve, reject) => {
    var data = JSON.stringify(where);
    var config = {
      method: "post",
      url: VUE_APP_API_OUT_URL + "/TrendTrade/mainTrend",
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };
    axios(config)
      .then(function (response) {
        resolve(JSON.parse(JSON.stringify(response.data)));
      })
      .catch(function (error) {
        reject(error);
      });
  });
}

// 获取情绪趋势数据
export function getEmotionTrend(where) {
  where.certificate_id = certificate_id;
  return new Promise((resolve, reject) => {
    var data = JSON.stringify(where);
    var config = {
      method: "post",
      url: VUE_APP_API_OUT_URL + "/TrendTrade/EmotionTrend",
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };
    axios(config)
      .then(function (response) {
        resolve(JSON.parse(JSON.stringify(response.data)));
      })
      .catch(function (error) {
        reject(error);
      });
  });
}

// 获取趋势排名数据
export function getTrendRank(where) {
  where.certificate_id = certificate_id;
  return new Promise((resolve, reject) => {
    var data = JSON.stringify(where);
    var config = {
      method: "post",
      url: VUE_APP_API_OUT_URL + "/TrendTrade/trendRank",
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };
    axios(config)
      .then(function (response) {
        resolve(JSON.parse(JSON.stringify(response.data)));
      })
      .catch(function (error) {
        reject(error);
      });
  });
}

// 趋势复盘表
export function pageDailyTrendReview(where) {
  return new Promise((resolve, reject) => {
    var data = JSON.stringify(where);
    var config = {
      method: "post",
      url: VUE_APP_API_OUT_URL5000 + "/dailyTrendReview",
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };
    axios(config)
      .then(function (response) {
        resolve(JSON.parse(JSON.stringify(response.data)));
      })
      .catch(function (error) {
        reject(error);
      });
  });
}
// 首板复盘表
export function pageFirstLimitUp(where) {
  return new Promise((resolve, reject) => {
    var data = JSON.stringify(where);
    var config = {
      method: "post",
      url: VUE_APP_API_OUT_URL5000 + "/firstLimitUp",
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };
    axios(config)
      .then(function (response) {
        resolve(JSON.parse(JSON.stringify(response.data)));
      })
      .catch(function (error) {
        reject(error);
      });
  });
}
// etf复盘表
export function pageEtfIndicators(where) {
  return new Promise((resolve, reject) => {
    var data = JSON.stringify(where);
    var config = {
      method: "post",
      url: VUE_APP_API_OUT_URL5000 + "/etfIndicators",
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };
    axios(config)
      .then(function (response) {
        resolve(JSON.parse(JSON.stringify(response.data)));
      })
      .catch(function (error) {
        reject(error);
      });
  });
}
// etf复盘表
export function listIndustryTrendRanking(where) {
  return new Promise((resolve, reject) => {
    var data = JSON.stringify(where);
    var config = {
      method: "post",
      url: VUE_APP_API_OUT_URL5000 + "/getIndustryTrendRanking",
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };
    axios(config)
      .then(function (response) {
        resolve(JSON.parse(JSON.stringify(response.data)));
      })
      .catch(function (error) {
        reject(error);
      });
  });
}
